"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeCoupon = exports.addCoupon = exports.addCustomWarranty = exports.addWarranty = exports.removeItem = exports.updateItem = exports.addItem = exports.getCartData = exports.createCartId = void 0;
const cart_utils_1 = require("../cart.utils");
const queries_1 = require("./queries");
const createCartId = async (apiRoute) => {
    let emptyCart = null;
    try {
        const query = queries_1.CREATE_CART;
        const { createEmptyCartV2 } = await (0, cart_utils_1.api)(apiRoute, { query });
        emptyCart = createEmptyCartV2.cartId;
    }
    catch (error) {
        const errorMessage = `Error creating the cart`;
        (0, cart_utils_1.buildErrorMessage)('[Shared Cart Service: createCart]:', errorMessage, error);
    }
    return emptyCart;
};
exports.createCartId = createCartId;
const getCartData = async (cartId, apiRoute) => {
    let cartData = null;
    try {
        const query = queries_1.GET_CART;
        const variables = { cartId };
        cartData = await (0, cart_utils_1.api)(apiRoute, { query, variables });
    }
    catch (error) {
        const errorMessage = `Error getting cart data with id: ${cartId}`;
        (0, cart_utils_1.buildErrorMessage)('[Shared Cart Service:  getCart]:', errorMessage, error);
    }
    return cartData;
};
exports.getCartData = getCartData;
const addItem = async (cartId, items, apiRoute) => {
    let updatedCart = null;
    try {
        const cartItems = items.map((item) => {
            let bundleOptions = null;
            if (item.bundleOptions) {
                bundleOptions = Array.isArray(item.bundleOptions)
                    ? item.bundleOptions[0]
                    : item.bundleOptions;
            }
            return {
                sku: item.sku,
                quantity: item.quantity,
                bundleOptions
            };
        });
        const query = queries_1.ADD_PRODUCTS_TO_CART;
        const variables = {
            cartId,
            cartItems
        };
        const { addProductsToCartV2 } = await (0, cart_utils_1.api)(apiRoute, { query, variables });
        updatedCart = addProductsToCartV2;
    }
    catch (error) {
        const errorMessage = `Error for cartId ${cartId} with data: item: ${JSON.stringify(items)}`;
        (0, cart_utils_1.buildErrorMessage)('[Shared Cart Service: addItem]:', errorMessage, error);
    }
    return updatedCart;
};
exports.addItem = addItem;
const updateItem = async (cartId, item, quantity, apiRoute) => {
    let updatedCartData = null;
    try {
        const query = queries_1.UPDATE_CART_ITEMS;
        const isPillowBundle = (0, cart_utils_1.canBeABundle)(item);
        const itemsToUpdate = isPillowBundle ? { sku: item.sku, itemId: item.id, quantity } : { itemId: item.id, quantity };
        const variables = {
            cartId,
            itemsToUpdate
        };
        const { updateCartItemsV2 } = await (0, cart_utils_1.api)(apiRoute, { query, variables });
        updatedCartData = updateCartItemsV2;
    }
    catch (error) {
        const errorMessage = `Error for cartId ${cartId} with data: item: ${JSON.stringify(item)}, quantity: ${quantity}`;
        (0, cart_utils_1.buildErrorMessage)('[Shared Cart Service: updateItem]:', errorMessage, error);
    }
    return updatedCartData;
};
exports.updateItem = updateItem;
const removeItem = async (cartId, itemId, apiRoute) => {
    let removeItemData = null;
    try {
        const query = queries_1.REMOVE_ITEM_FROM_CART;
        const variables = {
            cartId,
            itemId
        };
        const { removeItemFromCartV2 } = await (0, cart_utils_1.api)(apiRoute, { query, variables });
        removeItemData = removeItemFromCartV2;
    }
    catch (error) {
        const errorMessage = `Error for cartId ${cartId} with data: itemId: ${itemId}`;
        (0, cart_utils_1.buildErrorMessage)('[Shared Cart Service: removeItem]:', errorMessage, error);
    }
    return removeItemData;
};
exports.removeItem = removeItem;
const addWarranty = async (cartId, qty, warrantyDetails, apiRoute) => {
    let updatedCartData = null;
    try {
        const query = queries_1.ADD_WARRANTY_TO_CART;
        const variables = {
            cartId,
            qty,
            warranty: {
                ...warrantyDetails
            }
        };
        const { addWarrantyToCartV2 } = await (0, cart_utils_1.api)(apiRoute, { query, variables });
        updatedCartData = addWarrantyToCartV2;
    }
    catch (error) {
        const errorMessage = `Error for cartId ${cartId} with data: qty: ${qty}, warrantyDetails: ${JSON.stringify(warrantyDetails)}`;
        (0, cart_utils_1.buildErrorMessage)('[Cart checkout: addWarranty]:', errorMessage, error);
    }
    return updatedCartData;
};
exports.addWarranty = addWarranty;
const addCustomWarranty = async (cartId, qty, warrantyDetails, apiRoute, leadToken) => {
    let updatedCartData = null;
    try {
        const query = queries_1.ADD_CUSTOM_WARRANTY_TO_CART;
        const variables = {
            cartId,
            qty,
            warranty: {
                ...warrantyDetails
            },
            leadToken
        };
        const { addCustomWarrantyToCartV2 } = await (0, cart_utils_1.api)(apiRoute, { query, variables });
        updatedCartData = addCustomWarrantyToCartV2;
    }
    catch (error) {
        const errorMessage = `Error for cartId ${cartId} with data: qty: ${qty}, warrantyDetails: ${JSON.stringify(warrantyDetails)}`;
        (0, cart_utils_1.buildErrorMessage)('[Cart checkout: addCustomWarranty]:', errorMessage, error);
    }
    return updatedCartData;
};
exports.addCustomWarranty = addCustomWarranty;
const addCoupon = async (cartId, couponCode, apiRoute) => {
    let updatedCartData = null;
    try {
        const query = queries_1.APPLY_COUPON_TO_CART;
        const variables = {
            cartId,
            couponCode
        };
        const { applyCouponToCartV2 } = await (0, cart_utils_1.api)(apiRoute, { query, variables });
        updatedCartData = applyCouponToCartV2;
    }
    catch (error) {
        const errorMessage = `Error for cartId ${cartId} - Cannot add couponCode: ${couponCode}`;
        (0, cart_utils_1.buildErrorMessage)('[Shared Cart Service: addCoupon]:', errorMessage, error, false);
    }
    return updatedCartData;
};
exports.addCoupon = addCoupon;
const removeCoupon = async (cartId, apiRoute) => {
    let updatedCartData = null;
    try {
        const query = queries_1.REMOVE_COUPON_FROM_CART;
        const variables = {
            cartId
        };
        const { removeCouponFromCartV2 } = await (0, cart_utils_1.api)(apiRoute, { query, variables });
        updatedCartData = removeCouponFromCartV2;
    }
    catch (error) {
        const errorMessage = `Error for cartId ${cartId} - Cannot remove applied couponCode`;
        (0, cart_utils_1.buildErrorMessage)('[Shared Cart Service: removeCoupon]:', errorMessage, error, false);
    }
    return updatedCartData;
};
exports.removeCoupon = removeCoupon;
//# sourceMappingURL=actions.js.map